export const singularProfileContainer = {
  display: "flex",
  flexDirection: "column",

  alignItems: "center",
};

export const images = {
  height: "0",
  width: "100%",

  position: "relative",
  mb: "20px",
  paddingTop: `${(140 / 600) * 100}%`,
  border: "solid 1px",
  borderColor: "grey5",
};

export const baseImage = ({ baseImage }) => ({
  backgroundImage: `url(${baseImage})`,
  backgroundSize: "contain",

  backgroundColor: "transparent",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50%  0%",
  height: "100%",
  width: "100%",

  top: 0,
  left: 0,
  position: "absolute",
});
export const overlayedImage = ({ overlayedImage, overlayedImageWidth }) => ({
  backgroundImage: `url(${overlayedImage})`,
  backgroundSize: "contain",
  backgroundColor: "transparent",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "50%  0%",
  height: "100%",
  width: "100%",
  clipPath: `polygon(${overlayedImageWidth}% 0px, ${
    100 - overlayedImageWidth
  }% 0px, ${100 - overlayedImageWidth}% 100%,
    ${overlayedImageWidth}% 100%)`,

  transition: "clip-path 0.3s ease-out",
  position: "absolute",
  left: 0,
  top: 0,
});

export const optionsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "10px",
  width: "100%",
};

export const option = ({ isSelected }) => ({
  height: "40px",
  textAlign: "center",
  padding: "8px",
  border: "solid 1px",
  borderRadius: "2px",
  borderColor: isSelected ? "primary" : "grey5",
  color: isSelected ? "white" : "text",
  background: isSelected ? "primary" : "white",
  flexGrow: "1",
  flexShrink: "1",
  flexBasis: "auto",
  cursor: "pointer",
  minWidth: "80px",
});
